const ENV_UPDATED = (state, env) => {
  state.env = env
  localStorage.setItem('playerList.env', env)
}

const ROOTURL_UPDATED = (state, url) => {
  state.rootUrl = url
}

const LOADING_UPDATED = (state, loading) => {
  state.loading = loading
}

const SETTINGS_UPDATED = (state, settings) => {
  state.settings = settings
}

export default {
  ENV_UPDATED,
  ROOTURL_UPDATED,
  LOADING_UPDATED,
  SETTINGS_UPDATED
}



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js